import axiosPrivateMl from "./axiosPrivateMl";

const createDuplicateCampaign = async (payload) => {
  // POST to /duplicate_campaign_simple endpoint
  const response = await axiosPrivateMl.post("/duplicate_campaign_simple", payload);
  return response.data;
};

export default createDuplicateCampaign;
